module.exports = __webpack_public_path__ + "img/levelup-background-element.d4c192a0.svg";